export default {
  'ArtistBioSection.about': { en: 'About', fr: 'Sur' },
  'ArtistBioSection.viewless': { en: 'View less', fr: 'Voir moins' },
  'ArtistBioSection.continue': {
    en: 'Continue reading.',
    fr: 'Continuer la lecture.',
  },
};
